import { render, staticRenderFns } from "./LayoutMenu.vue?vue&type=template&id=19836708&scoped=true"
import script from "./LayoutMenu.vue?vue&type=script&lang=js"
export * from "./LayoutMenu.vue?vue&type=script&lang=js"
import style0 from "./LayoutMenu.vue?vue&type=style&index=0&id=19836708&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "19836708",
  null
  
)

export default component.exports